<template>
  <div class="open-class" v-title :data-title="'卓考网校|'+ professionName +'|公开课入口'">
    <main class="g-view-container">
      <article>
        <h1 class="title">公开课</h1>
        <section class="section">
          <h2 class="headline">近期直播</h2>
          <template v-if="!liveList || !liveList.length">
            <p class="no-data">暂无近期直播</p>
          </template>
          <div v-else class="open-class-list">
            <template v-for="(item) in liveList">
              <open-class-item
                class="item"
                :key="item.liveDetailId"
                :type="item.liveStatus"
                :title="item.subName"
                :name="item.teacher"
                :time="item.startTimeStr"
                :num="item.personNum"
                :avatar="getTeacherAvatar(item.teacherId)"
                @reserve="onReserve"
                @live="onLive(item.liveDetailId)"
                @replay="onReplay(item.isHasReplay, item.replayUrl)"
              />
            </template>
          </div>
        </section>
        <section class="section">
          <h2 class="headline">直播回放</h2>
          <template v-if="!replayList || !replayList.length">
            <p class="no-data">暂无直播回放</p>
          </template>
          <div v-else class="open-class-list">
            <template v-for="(item) in replayList">
              <open-class-item
                class="item"
                :key="item.liveDetailId"
                :type="item.liveStatus"
                :title="item.subName"
                :name="item.teacher"
                :time="item.startTimeStr"
                :num="item.personNum"
                :avatar="getTeacherAvatar(item.teacherId)"
                @reserve="onReserve"
                @live="onLive(item.liveDetailId)"
                @replay="onReplay(item.isHasReplay, item.replayUrl)"
              />
            </template>
            <van-loading v-if="loading" class="loading" />
            <template v-else>
              <div v-if="hasNext" class="more" @click="onLoadMore">点击查看更多</div>
              <div v-else class="no-more">没有更多数据了</div>
            </template>
          </div>
        </section>
        <div class="btn-lecture" @click="onTeacher">私聊老师</div>
        <van-dialog v-model="showReserve" :show-confirm-button="false" closeOnPopstate>
          <div class="dialog">
            <p class="tip">
              微信扫码
              <br />完成预约
            </p>
            <img class="image" :src="`https://files.zhuokao360.com/images/openclass/${professionId}.png`" />
            <p class="cancel" @click="onCancle">下次再说</p>
          </div>
        </van-dialog>
        <van-dialog v-model="showTeacher" :show-confirm-button="false" closeOnPopstate>
          <div class="dialog">
            <p class="tip">
              微信扫码
              <br />领取讲义
            </p>
            <img class="image" src="../../assets/img/open-class/qrcode@teacher.png" />
            <p class="cancel" @click="onCancle">下次再说</p>
          </div>
        </van-dialog>
      </article>
    </main>
  </div>
</template>

<script>
  import Course from 'models/course';
  import OpenClassItem from './item';

  export default {
    name: 'OpenClass',
    components: {
      OpenClassItem,
    },
    data() {
      return {
        professionId: this.$route.params.professionId || 1,
        professionName: '',
        liveList: [],
        replayList: [],
        hasNext: false,
        currentPage: 1,
        loading: false,
        showReserve: false,
        showTeacher: false,
      };
    },
    computed: {},
    created() {
      this.professionName = Course.getProfessionName(this.professionId);
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      Course.getLiveList(this.professionId, this.currentPage)
        .then((res) => {
          this.$toast.clear();
          if (res.data.code === 200) {
            const {
              hasNext,
              data: { 1: liveList, 2: replayList },
            } = res.data;
            this.preprocessing(liveList);
            this.hasNext = hasNext;
            this.liveList = liveList;
            this.replayList = replayList;
          }
        })
        .catch(() => {
          this.$toast('小主您的网络开小差了，请刷新重试~');
        });
    },
    methods: {
      getTeacherAvatar(teacherId) {
        if (teacherId === 11) {
          return require('../../assets/img/teacher/wangchengyao.png');
        }
        if (teacherId === 12) {
          return require('../../assets/img/teacher/miaochangjing.png');
        }
        if (teacherId === 13) {
          return require('../../assets/img/teacher/xiaofeng.png');
        }
        if (teacherId === 14) {
          return require('../../assets/img/teacher/cui.png');
        }
        return require('../../assets/img/teacher/10.png');
      },

      onReserve() {
        this.showReserve = true;
      },

      onTeacher() {
        this.showTeacher = true;
      },

      onCancle() {
        this.showReserve = false;
        this.showTeacher = false;
      },

      onLive(liveDetailId) {
        window.location.href = `https://cj.tibaitong.com/free/live?liveDetailId=${liveDetailId}`;
      },

      onReplay(isHasReplay, replayUrl) {
        if (+isHasReplay === 0) {
          this.$toast('小主不要着急，正在生成回放中~');
        } else {
          window.location.href = replayUrl;
        }
      },

      onLoadMore() {
        if (this.hasNext && !this.loading) {
          this.loading = true;
          Course.getLiveList(this.professionId, this.currentPage + 1).then(
            (res) => {
              this.loading = false;
              if (res.data.code === 200) {
                const {
                  page,
                  hasNext,
                  data: { 2: replayList },
                } = res.data;
                this.currentPage = page;
                this.hasNext = hasNext;
                this.replayList = this.replayList.concat(replayList);
              }
            },
          );
        }
      },

      preprocessing(arr) {
        if (!(arr instanceof Array)) {
          return;
        }
        const newArr = arr;
        for (let i = 0, len = newArr.length; i < len; i += 1) {
          // 状态调整
          if (newArr[i].liveStatus === 0) {
            const startTime = new Date(newArr[i].startTimeStr);
            const now = new Date();
            if (+now > +startTime - 30 * 60 * 1000) {
              newArr[i].liveStatus = 1;
            }
          } else if (newArr[i].liveStatus === 1) {
            if (+newArr[i].isHasReplay === 1) {
              newArr[i].liveStatus = 2;
            }
          } else if (newArr[i].liveStatus === 2) {
            if (+newArr[i].isHasReplay === 0) {
              newArr[i].liveStatus = 1;
            }
          }

          // 人数虚增
          newArr[i].personNum += 500;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.title {
  margin-top: 15px;
  font-size: 14px;
  color: #333;
  text-align: center;
  line-height: 30px;
  font-weight: normal;
}

.section {
  margin-top: 15px;
}

.headline {
  display: flex;
  align-items: center;
  margin-left: 10px;
  font-size: 16px;
  color: #333;
  font-weight: normal;

  &::before {
    content: "";
    margin-right: 5px;
    width: 4px;
    height: 16px;
    background-color: #3c59f5;
  }
}

.no-data {
  margin: 20px 0 20px 20px;
  color: #666;
}

.open-class-list {
  margin: 20px 4% 0;

  .item {
    margin-bottom: 20px;
  }
}

.more {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  color: #999;

  &::after {
    margin-left: 5px;
    content: "";
    width: 12px;
    height: 12px;
    background: url(../../assets/img/arrow@down.png) no-repeat center;
    background-size: contain;
  }
}

.no-more {
  color: #999;
  text-align: center;
}

.loading {
  text-align: center;
}

.btn-lecture {
  position: fixed;
  left: calc(50% - 74px);
  bottom: 25px;
  width: 148px;
  height: 28px;
  color: #fff;
  text-align: center;
  line-height: 28px;
  background-color: #3ca5f6;
  border-radius: 4px;
}

.van-dialog {
  width: 64%;
  max-width: 400px;
}

.dialog {
  display: flex;
  flex-direction: column;
  align-items: center;

  .tip {
    margin: 12px 0 4px;
    font-size: 17px;
    color: #333;
    line-height: 24px;
  }

  .image {
    width: 75%;
    max-width: 300px;
  }

  .cancel {
    margin: 2px 0 12px;
    font-size: 10px;
    color: #999;
  }

  .em {
    margin: 0 2px;
    font-size: 16px;
    color: red;
  }
}
</style>
